module.exports = __webpack_public_path__ + "static/media/debt-credit-v4.8c4ed15b.svg";